import React, { Component } from 'react';
import { Input, Form } from 'antd';

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

export const EditableFormRow = Form.create()(EditableRow);

export class EditableCell extends Component {
  save = (e, enter) => {
    e.stopPropagation();
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      handleSave(
        {
          ...record,
          ...values,
        },
        enter
      );
    });
  };

  renderCell = (form) => {
    this.form = form;
    const { children, dataIndex, record, title, editing, nameClick } =
      this.props;
    return editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
      >
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required`,
            },
          ],
          initialValue: record[dataIndex],
        })(
          <Input
            style={{
              background: 'transparent',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.08)',
            }}
            ref={(node) => (this.input = node)}
            onClick={(e) => e.stopPropagation()}
            onPressEnter={(e) => this.save(e, true)}
          />
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={(e) => {
          nameClick(record);
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}
